import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import InputForm from '../form/InputForm';
import Buttons from '../form/Buttons';
import { formatDateTime, slice } from '../../utils';
import { iNewDataProcess, iUser } from '../type';
import Dropdown from '../Dropdown';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../stores';
import { AssignProcessToFolderModal, EditprocessModal, GenericModal, PublishModal } from '../../views/modal';

interface ProcessTableRowProps {
    data: any;
    index: number;
    interviewTime: string | null;
    editableData: any;
    users: iUser;
    handleDateChange: (processId: string, date: Date) => void;
    handleInputChange: (processId: string, field: string, value: string) => void;
    requestChange: (processId: string) => void;
    updateProcessData: (processId: string) => void;
    loadingProcesses: any;
    deleProcess: () => void;
    setProcess: (form: iNewDataProcess) => void;
    onMappingClick?: (processId: string, mapId: string) => void;
}

const ProcessTableRow: React.FC<ProcessTableRowProps> = ({
    data,
    interviewTime,
    editableData,
    users,
    handleDateChange,
    handleInputChange,
    requestChange,
    updateProcessData,
    loadingProcesses,
    deleProcess,
    setProcess,
    onMappingClick,

}) => {
    const approver = data.swimlane?.approver;
    const role = useAppSelector((state) => state.role.role);
    const { t } = useTranslation()
    const isSaveButtonVisible = (
        (editableData[data.Process?._id]?.metrics?.trim() || '') !== (data.Process?.metrics || '') ||
        (editableData[data.Process?._id]?.revision_triggers?.trim() || '') !== (data.Process?.revision_triggers || '') ||
        (editableData[data.Process?._id]?.next_revision_date || '') !== (data.Process?.next_revision_date || '')
    );

    return (
        <>

            <tr className="small ms-1 process-folder-table-row w-100 ps-1 fs-6" key={data._id}>
                <td className="align-middle border-top-0">
                    <Dropdown
                        classMenu='position-absolute'
                        dropName=''
                        dropdownType='dropdown dropstart '
                        iconClassName={((role !== 'WORKER')) ? 'fa fa-ellipsis-h' : ""}
                        buttonDropClassName={`${(role !== 'WORKER') ? 'btn btn-secondary bg-transparent border-0 process-folder-table-menu-btn' : 'btn btn-transparent disabled border-0 process-folder-table-muted '}`}
                        styleButton={{}}
                        action3={`${t('words.organize')}`}
                        theRouteOfAction4=''
                        deleteProcess={deleProcess}
                        action1=''
                        theRouteOfAction5=''
                        dataBsTarget={`#asignProcessToFolder${data.Process?._id}`}
                        routeFaq=''
                        edit={`${t('words.rename')}`}
                        dataBsTargetEdit={`#edit${data.Process?._id}`}
                        publish={`${t('navigation.markAsFinal')}`}
                        dataBsTargetPublish={`#publish${data.Process?._id}`}
                        onClick={() => { }}
                        action7={t('words.delete')}
                        dataBsTargetAction7={`#generic${data.Process?._id}`}

                    />
                </td>
                <td className="align-middle border-top-0" title={data.Process?.title.length > 20 ? data.Process?.title : ""}>
                    {data.hasMapping && users._id === data.Process?.owner._id ? (
                        <button
                            type="button"
                            className="btn btn-link process-folder-table-link p-0 border-0 text-start"
                            onClick={() => {
                                const pid = data.Process?._id;
                                const mid = data.swimlane?._id;
                                if (pid && mid) onMappingClick?.(pid, mid);
                            }}
                        >
                            {slice(data.Process?.title, 20)}
                        </button>
                    )
                        :
                        <span>{slice(data.Process?.title, 20)}</span>
                    }
                </td>
                <td className="align-middle border-top-0">
                    <span>{data.Process.owner.fullname}</span>
                </td>

                <td className="align-middle border-top-0">
                    <span>{formatDateTime(data.Process.created_at)}</span>
                </td>
                {/* <td className="align-middle border-top-0">
                {mapStatus[data.Process._id] && users._id === data.Process.owner._id ? (
                    <a href={`${Routes.MAPPING}${data.Process._id}/${data.swimlane?._id}`}>
                    </a>
                ) : (data.swimlane?.name ?
                    <span>{slice(data.swimlane?.name, 20)}</span>
                    :
                    <span className="process-folder-table-muted">—</span>
                )}
            </td> */}
                <td className="align-middle border-top-0">
                    {(approver?.fullname || approver?.email) ?
                        <span>
                            {approver?.fullname
                                ? approver.fullname
                                : approver?.email
                            }
                        </span>
                        :
                        <span className="process-folder-table-muted">—</span>
                    }
                </td>

                <td className="align-middle border-top-0">
                    <span>{approver ? formatDateTime(data.swimlane?.updated_at) : <span className="process-folder-table-muted">—</span>}</span>
                </td>
                <td className="align-middle border-top-0">
                    {interviewTime ? <span>
                        {interviewTime}
                        {interviewTime && ' Minutes'}
                    </span> :
                        <span className="process-folder-table-muted">—</span>
                    }
                </td>
                <td className="align-middle border-top-0">
                    <DatePicker
                        selected={
                            editableData[data.Process._id]?.next_revision_date
                                ? new Date(editableData[data.Process._id]?.next_revision_date)
                                : null
                        }
                        onChange={(date) => handleDateChange(data.Process._id, date as Date)}
                        showTimeSelect
                        dateFormat="yyyy-MM-dd HH:mm:ss"
                        className="form-control process-folder-table-input"
                        calendarClassName="process-folder-datepicker"
                        wrapperClassName="process-folder-datepicker-wrap"
                    />
                </td>
                <td className="align-middle border-top-0">
                    <InputForm
                        inputType="text"
                        inputLabel="Metrics"
                        inputName="metrics"
                        inputValue={editableData[data.Process._id]?.metrics || ''}
                        isFloatingLabel={true}
                        labelClass="text-theme"
                        onChange={(e) =>
                            handleInputChange(data.Process._id, 'metrics', (e.target as HTMLInputElement).value)
                        }
                        inputContainerClass={''}
                        simpleInput={true}
                        inputClass="process-folder-table-input"
                    />
                </td>
                <td className="align-middle border-top-0">
                    <InputForm
                        inputType="text"
                        inputLabel="Revision Triggers"
                        inputName="revision_triggers"
                        inputValue={editableData[data.Process._id]?.revision_triggers || ''}
                        isFloatingLabel={true}
                        labelClass="text-theme"
                        onChange={(e) =>
                            handleInputChange(data.Process._id, 'revision_triggers', (e.target as HTMLInputElement).value)
                        }
                        inputContainerClass={''}
                        simpleInput={true}
                        inputClass="process-folder-table-input"
                    />
                </td>
                <td className="align-middle border-top-0 text-center">
                    {users._id === data.Process.owner._id && isSaveButtonVisible ? (
                        <Buttons
                            buttonType="submit"
                            name={!loadingProcesses[data.Process._id] ? 'Save' : ''}
                            onClick={() => updateProcessData(data.Process._id)}
                            isLoading={false}
                            btnClass="btn-theme process-folder-table-action border-0 btn-sm"
                            labelClass="text-white fw-bold"
                            styleProps={{}}
                            withIcon={loadingProcesses[data.Process._id]}
                            iconName="fa-solid fa-spinner text-white process-folder-table-action"
                            btnStyle={{ height: 58 }}
                            arrowVisible={false}
                            arrowColor=""
                        />
                    ) : isSaveButtonVisible ? (
                        <Buttons
                            buttonType="submit"
                            name={!loadingProcesses[data.Process._id] ? 'Request Change' : ''}
                            onClick={() => requestChange(data.Process._id)}
                            isLoading={false}
                            btnClass="btn-theme process-folder-table-action border-0 btn-sm"
                            labelClass="text-white fw-bold"
                            styleProps={{}}
                            withIcon={loadingProcesses[data.Process._id]}
                            iconName="fa-solid fa-spinner text-white process-folder-table-action"
                            btnStyle={{ height: 58 }}
                            arrowVisible={false}
                            arrowColor=""
                        />
                    ) : (
                        <button className='btn btn-transparent'></button>
                    )}
                </td>

                <td className="align-middle border-top-0">
                    <GenericModal
                        title={t('words.delete')}
                        actionButton={t('words.delete')}
                        action={deleProcess}
                        sentence={t('views.processView.areYouSure')}
                        processId={data.Process._id}
                    />
                    <PublishModal processId={data.Process?._id} />
                    <AssignProcessToFolderModal
                        processId={data.Process._id}
                        processName={data.Process?.title}
                    />
                    <EditprocessModal
                        folder={false}
                        processId={data.Process?._id}
                        processName={data.Process?.title}
                        description={data.Process?.description}
                        setProcess={setProcess}
                    />

                </td>
            </tr>


        </>
    );
};

export default ProcessTableRow;

